import React from 'react';
import {connect} from 'react-redux';
import {ComboExposureMax as BaseComboExposureMax} from 'components/molecules/combo-exposure-max';
import Action from 'components/organisms/key-player-combinations/actions';
import NumberHelper from 'helpers/number-helper';

class ComboExposureMax extends BaseComboExposureMax {
    constructor(props) {
        super(props);
        this.action = Action;
    }

    prepareValue(value) {
        const {lineupsQuantity} = this.props;
        return NumberHelper.prepareInt(value, 0)
            .limitByRange(0, lineupsQuantity.getLineupsQuantity(), 0, lineupsQuantity.getLineupsQuantity())
            .get();
    }

    getDefaultValue() {
        const {defaultValue = ''} = this.props;
        return defaultValue;
    }
}

function mapStatesToProps(state) {
    const {
        keyPlayerStacking: {combinations},
        lineupsQuantity,
    } = state;

    return {
        comboExpMax: combinations.exposureMax,
        lineupsQuantity,
    };
}

export default connect(mapStatesToProps)(ComboExposureMax);
